import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewIconButonAriaLabel: {
		id: 'polaris-ideas.sidebar.sections.view-item.view-icon-buton-aria-label',
		defaultMessage: 'Change view icon',
		description: 'Aria label for the icon that open the icons popup to change the view icon',
	},
});
